import { QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';

import FrontImage from '../../assets/images/LandingPage/frontImg.png';
import { CheckoutCanceledModal } from '../../components/_molecules/CheckoutCanceledModal/CheckoutCanceledModal';
import PricingPageContent from '../../components/_organisms/PricingPageContent';
import { PricingPageHeader } from '../../components/_organisms/PricingPageContent/PricingPageHeader';
import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import { useLocale } from '../../hooks/useLocale';
import { DefaultLocale } from '../../providers/tolgee';
import {
  detectAndBestEffortSetLanguage,
  getLocaleRedirectIfNeeded,
} from '../../utils/localisationUtils';
import { getReadOnlyServerSession } from '../../utils/serverSession';
import { provisionFlags } from '../../utils/ServerSideFeatureFlagUtils';

const PricingPage: NextPageWithLayout = () => {
  useLocale();

  // Paused until decision on product event
  // useEffect(() => {
  //   // Track pricing page views for target roles
  //   const targetRoles = [
  //     'Instructional/Tech Coach',
  //     'School Administrator',
  //     'District Administrator',
  //     'Purchasing Manager',
  //     'adminDistrict',
  //   ];

  //   const userRole = accessBadge?.user?.profileInfo?.role;
  //   const organizationId = accessBadge?.organization?.id;
  //   const email = accessBadge?.user?.email;
  //   const userId = accessBadge?.user?.id;

  //   if (userRole && targetRoles.includes(userRole) && organizationId && userId && email) {
  //     trackAttioEvent('admin_pricing_page_view', {
  //       organizationId,
  //       userRole,
  //       userId,
  //       email,
  //       firstName: accessBadge?.user?.firstName,
  //       lastName: accessBadge?.user?.lastName,
  //     });
  //   }
  // }, [accessBadge, trackAttioEvent]);

  return (
    <>
      <CheckoutCanceledModal />
      <LandingPageLayout
        title="Pricing"
        subTitle="Pricing details for educators bringing curiosity into the classroom"
        locale={DefaultLocale}
        primaryActionText="Sign up - It's free"
        image={FrontImage}
        hideBlobs={false}
        customHeader={<PricingPageHeader />}
        disableHeadline={true}
      >
        <PricingPageContent />
      </LandingPageLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  const localeRedirect = getLocaleRedirectIfNeeded(context, '/pricing');
  if (localeRedirect) return localeRedirect;

  // Read-only: public marketing page; the session only seeds flag targeting.
  const session = await getReadOnlyServerSession(context.req);
  const queryClient = new QueryClient();
  // Provision flags server-side so the client Unleash instance bootstraps with the
  // correct values on the very first render — see pages/signin.tsx.
  const flags = await provisionFlags(context, queryClient, session);

  return {
    props: {
      ...flags,
      ...(await detectAndBestEffortSetLanguage(context, { routeClass: 'marketing' })),
    },
  };
};

export default PricingPage;
